<template>
    <div>
        <div class="add-home">
            <el-row>
                <div class="channel" v-loading="loading">
                    <!-- <div class="title">{{channelTitle}}渠道提报</div> -->
                    <!-- <div class="type-tab">
                        <el-tabs  type="card" @tab-click="handleClick" :value="getActiveName(tabArr)" >
                            <el-tab-pane
                            v-for="(item) in tabArr"
                            :key="item.themeStyleCode "
                            :label="item.themeStyleName"
                            :name="item.themeStyleName"
                            >
                                <div class="child" v-if="item.data[0].themeDetail.themeLevelCode !==null">
                                    <el-tabs  v-model="activeName" tab-position="left" @tab-click="handleClickson" >
                                        <el-tab-pane
                                        v-for="(i) in item.data"
                                        :key="i.themeDetail.themeLevelCode"
                                        :label="i.themeDetail.themeLevelName"
                                        :name="i.themeDetail.themeLevelName" >
                                            <AddForm
                                             :popDataitem="i"
                                             :igniteOptions="igniteOptions"
                                             :regionCode="regionCode"
                                             @addPopsale="addPopsale"
                                             @clickOperate="clickOperate"
                                             @setLoading="setLoading"
                                             ></AddForm>
                                        </el-tab-pane>
                                    </el-tabs>
                                </div>
                                <div class="father" v-else>
                                    <AddForm
                                     :igniteOptions="igniteOptions"
                                     :regionCode="regionCode"
                                     @addPopsale="addPopsale"
                                     :popDataitem="item"
                                     @setLoading="setLoading"
                                     ></AddForm>
                                </div>
                            </el-tab-pane>
                        </el-tabs>
                    </div> -->
                    <AddForm
                    :igniteOptions="igniteOptions"
                    :regionCode="regionCode"
                    @addPopsale="addPopsale"
                    :popDataitem="dataForm"
                    :gpActivityInfoVOList="gpActivityInfoVOList"
                    @setLoading="setLoading"
                    ></AddForm>
                </div>
            </el-row>
        </div>
    </div>
</template>
<script>
    import { mapGetters } from 'vuex'
    import AddForm from './activity-report-add-pop-form.vue'
    export default {
      name: 'activity-report-add-pop',
      props: {
        channelForm:{type:Object, default:()=>{} },
        dataForm:{type:Object, default:()=>{} },
        igniteOptions:{type:Object, default:()=>{} },
        themeBasic:{type:Object, default:()=>{} },
        regionCode:{type:String, default:'' },
        gpActivityInfoVOList:{type:Array, default:()=>[] },
      },
      components: {
        AddForm
      },
      data () {
        return {
            tabList:[],
            tabName:'地标',
            childName:'',
            tabArr: [],
            activeName: '',
            tabIndex: 0,
            channelTitle: '',
            itemData: '',
            allList:[],
            loading:false
        }
      },
      computed: {
        ...mapGetters(['userInfo']),
      },
      watch: {},
      created () {
        this.init()
      },
      mounted () {
        // const tab = {index: 0}
        // this.handleClick(tab)
      },
      updated () {
      },
      methods: {
        init () {
            // this.getChannelitem()
            // this.getAllList()
        },
        getChannelitem () {
            this.channelTitle = this.channelForm.themeChannelEnName
            let code = this.channelForm.themeChannelCode
            let itemList = []
            for (let i = 0; i < this.dataForm.length; i++) {
                if (code === this.dataForm[i].themeDetail.themeChannelCode) {
                        itemList.push({
                            'themeDetail':this.dataForm[i].themeDetail,
                            'gpActivityInfoVOList':this.dataForm[i].gpActivityInfoVOList,
                            'themeBasic':this.themeBasic,
                            'igniteRuleDTOList':this.dataForm[i].igniteRuleDTOList,
                            'curAssignList':this.dataForm[i].curAssignList
                        })
            }}
            this.allList = itemList
            this.getTaball(this.allList)
        },
        // getAllList () {
        //     let itemIndex = []
        //     for (let item of this.allList) {
        //         let index = itemIndex.indexOf(item.themeDetail.themeStyleCode)
        //         if (index === -1) {
        //             itemIndex.splice(0,0,item.themeDetail.themeStyleCode)
        //             let data = [
        //                 {
        //                 'themeLevelCode':item.themeDetail.themeLevelCode,
        //                 'themeStyleName':item.themeDetail.themeStyleName,
        //                 'themeStyleCode':item.themeDetail.themeStyleCode,
        //                 'themeDetail':item.themeDetail,
        //                 'gpActivityInfoVOList':item.gpActivityInfoVOList,
        //                 'themeBasic':this.themeBasic
        //                 }
        //             ]
        //             this.tabArr.push(data)

        //         } else {
        //             this.tabArr[index].push(
        //                 {
        //                     'themeLevelCode':item.themeDetail.themeLevelCode,
        //                     'themeStyleName':item.themeDetail.themeStyleName,
        //                     'themeStyleCode':item.themeDetail.themeStyleCode,
        //                     'themeDetail':item.themeDetail,
        //                     'gpActivityInfoVOList':item.gpActivityInfoVOList,
        //                     'themeBasic':this.themeBasic
        //                 }
        //             )
        //         }
        //     }
        //     this.tabList =  this.tabArr.map((item)=>{
        //         return item.themeStyleName || item[0].themeDetail.themeStyleName
        //     }).join('、')
        // },
        getTaball (arr) {
            let map = {}
            let dest = [];
            for(let i = 0; i < arr.length; i++){
                let ai = arr[i];
                if(!map[ai.themeDetail.themeStyleCode]){
                    dest.push({
                        'themeStyleCode': ai.themeDetail.themeStyleCode,
                        'themeStyleName': ai.themeDetail.themeStyleName,
                        'themeLevelCode':ai.themeDetail.themeLevelCode,
                        'themeLevelName':ai.themeDetail.themeLevelName,
                        // 'themeBasic':this.themeBasic,
                        data: [ai]
                    });
                    map[ai.themeDetail.themeStyleCode] = ai;
                }else{
                    for(let j = 0; j < dest.length; j++){
                        let dj = dest[j];
                        if(dj.themeStyleCode == ai.themeDetail.themeStyleCode){
                            dj.data.push(ai);
                            break;
                        }
                    }
                }
            }
            // console.log(dest,'dest');
            this.tabArr = dest
            this.tabList =  this.tabArr.map((item)=>{
                return item.themeStyleName
            }).join('、')
            return dest
        },
        // 点击操作
        clickOperate (row) {
            // console.log(row,'clickOperate-子');
        },
        addSale (val) {
            this.$emit("showSinglemask",val)
        },
        addManysale (val) {
            this.$emit("showManymask",val)
        },
        addPopsale(item) {
            // console.log(item,'addPopsale-子');
            this.$emit('addPopsale',item)
        },
        getActiveName(tabArr) {
            if (tabArr[0].data[0].themeDetail.themeLevelCode !== null) {
                this.activeName = tabArr[0].data[0].themeDetail.themeLevelName
                return tabArr[0].themeStyleName
            } else {
                return tabArr[0].themeStyleName
            }
            // if (tabArr[this.tabIndex].data[0].themeDetail.themeLevelCode !== null) {
            //     this.activeName = tabArr[this.tabIndex].data[0].themeDetail.themeLevelName
            //     return tabArr[this.tabIndex].themeStyleName
            // } else {
            //     return tabArr[this.tabIndex].themeStyleName
            // }
        },
        handleClick(tab) {
            let num = Number(tab.index)
            this.tabIndex = num
            if (this.tabArr[num].data[0].themeDetail.themeLevelCode !==null) {
                this.activeName = this.tabArr[num].data[0].themeDetail.themeLevelName
                // return this.tabArr[num].themeStyleName
            } else {
                this.activeName = this.tabArr[num].data[0].themeStyleName
                 // return this.tabArr[num].themeStyleName
            }
        },
        handleClickson (tab) {
        },
        setLoading (val) {
            this.loading = val
        },
    }
}
</script>
<style lang="scss" scoped>
    .is-hover-shadow:hover {
        box-shadow: 0 2px 20px 0 rgba(0, 0, 0, 0.2);
    }
    .add-home {
        // min-height: calc(100vh - 320px) !important;
        // font-family: SourceHanSansSC-regular;
        .channel {
            margin-top: 20px;
            .title {
                height: 50px;
                line-height: 50px;
                text-align: left;
                // height: 25px;
                color: rgba(16, 16, 16, 1);
                font-size: 18px;
                font-weight: 600;
            }
            .channel-type {
                padding: 10px 10px 10px 30px;
                background-color: #FFFFFF;
                color: #101010;
                border-radius: 8px;
                font-family: SourceHanSansSC-bold;
                font-size: 16px;
                font-weight: bold;
                height: 40px;
                line-height: 40px;
                display: flex;
                text-align: left;
                .left {
                    width: 20%;
                }
            }
            .type-tab {
                margin-top: 20px;
                ::v-deep .el-tabs__item.is-active {
                    background-color: #409EFF;
                    color: #FFFFFF;
                }
                ::v-deep .el-tabs__item {
                    color: #101010;
                    background-color: #FFFFFF;
                    text-align: center;
                    margin-right: 5px;
                    min-width: 100px;
                    border: none;
                    border-top-left-radius: 5px;
                    border-top-right-radius: 5px;
                    height: 42px;
                    padding: 0px !important;
                }
                ::v-deep .el-tabs__nav-scroll {
                    border-bottom: 0px;
                }
                ::v-deep .el-tabs--card>.el-tabs__header .el-tabs__nav {
                    border: 0;
                }
                // ::v-deep .el-tabs__content {
                //     overflow: hidden;
                //     position: relative;
                //     margin-top: -15px;
                //     background-color: #FFFFFF;
                //     padding: 20px 0px 0px 0px;
                //     border-radius: 8px;
                //     border-top-left-radius: 0px;
                // }
                ::v-deep .el-tabs--card>.el-tabs__header {
                    border-bottom: 0px solid #E4E7ED;
                }
                .child {
                    // background-color: #FFFFFF;
                    ::v-deep .el-tabs__item.is-active {
                    background-color: rgba(255, 255, 255, .1);
                    color: #409EFF;
                    }
                    ::v-deep .el-tabs__item {
                        color: #101010;
                        background-color: rgba(255, 255, 255, .1);
                        text-align: center;
                    }
                    ::v-deep .el-tabs__nav-scroll {
                        border-bottom: 0;
                        margin-right: 0px;

                    }
                    ::v-deep .el-tabs--card>.el-tabs__header .el-tabs__nav {
                        border: 0;
                        margin-bottom: 0px;
                    }
                }
            }
        }
    }
</style>
